import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getServiceMvnoOperations = async (token) => {
    log("welcome in getServiceMvnoOperations")

    if (!token || token === "") {
        return {error: true, message: "No token provided", operations: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_service_mvno_operations_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getServiceMvnoOperations")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getServiceMvnoOperations")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getServiceMvnoOperations", operations: []}
    }
}

export const addServiceMvnoOperation = async (token, data) => {
    log("welcome in addServiceMvnoOperation")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_service_mvno_operation_api'
        log("url=" + url)

        const payload = {
            service_id: data.service_id,
            service_operation_type_id: data.service_operation_type_id,
            mvno_api_method_id: data.mvno_api_method_id,
            api_params: data.api_params || null,
            description: data.description || null,
            active: data.active !== false
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios addServiceMvnoOperation")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in addServiceMvnoOperation")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addServiceMvnoOperation"}
    }
}

export const updateServiceMvnoOperation = async (token, data) => {
    log("welcome in updateServiceMvnoOperation")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_service_mvno_operation_api'
        log("url=" + url)

        const payload = {
            id: data.id,
            service_id: data.service_id,
            service_operation_type_id: data.service_operation_type_id,
            mvno_api_method_id: data.mvno_api_method_id,
            api_params: data.api_params,
            description: data.description,
            active: data.active
        }

        const result = await axios.put(url, payload, {headers: headers})
        log("result.data din axios updateServiceMvnoOperation")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateServiceMvnoOperation")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateServiceMvnoOperation"}
    }
}

export const deleteServiceMvnoOperation = async (token, id) => {
    log("welcome in deleteServiceMvnoOperation")

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/delete_service_mvno_operation_api'
        log("url=" + url)

        const result = await axios.delete(url, {headers: headers, data: {id: id}})
        log("result.data din axios deleteServiceMvnoOperation")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in deleteServiceMvnoOperation")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la deleteServiceMvnoOperation"}
    }
}

const useServiceMvnoOperationsAPI = () => {
    return {
        error,
        getServiceMvnoOperations,
        addServiceMvnoOperation,
        updateServiceMvnoOperation,
        deleteServiceMvnoOperation
    }
}

export default useServiceMvnoOperationsAPI
